/**
 * Type Defaults - Parent-child mappings between area and unit types
 *
 * These mappings are used by the layout designer to suggest default unit types
 * when creating units inside a building. They are NOT enforced strictly.
 */

import type { AreaType } from './hangars'
import type { UnitType, CapacityStrategy } from './units'

/** Default unit type suggestion for each area structural type */
export const DEFAULT_UNIT_TYPE_FOR_AREA: Record<AreaType, UnitType> = {
  single_unit_hangar: 'conventional_hangar',
  box_hangar_single_row: 'box_hangar',
  box_hangar_double_row: 'box_hangar',
  t_hangar_row: 't_hangar',
  nested_t_hangar_row: 't_hangar',
  arch_hangar: 'conventional_hangar',
  tiedown_area: 'tiedown',
  ramp_area: 'ramp',
  shade_structure: 'shade',
  terminal: 'office',
  office: 'office',
  custom: 'custom',
}

/** Default capacity strategy for each unit structural type */
export const DEFAULT_CAPACITY_FOR_UNIT: Record<UnitType, CapacityStrategy> = {
  conventional_hangar: 'stackable',
  box_hangar: 'single',
  t_hangar: 'single',
  shade: 'stackable',
  tiedown: 'single',
  ramp: 'single',
  office: 'single',
  storage: 'single',
  shop: 'single',
  custom: 'single',
}

/** Allowed unit types for each area type (for UI hints, not strict enforcement) */
export const ALLOWED_UNIT_TYPES_FOR_AREA: Record<AreaType, UnitType[]> = {
  single_unit_hangar: ['conventional_hangar', 'office', 'storage', 'shop', 'custom'],
  box_hangar_single_row: ['box_hangar', 'office', 'storage', 'shop', 'custom'],
  box_hangar_double_row: ['box_hangar', 'office', 'storage', 'shop', 'custom'],
  t_hangar_row: ['t_hangar', 'custom'],
  nested_t_hangar_row: ['t_hangar', 'custom'],
  arch_hangar: ['conventional_hangar', 'office', 'storage', 'shop', 'custom'],
  tiedown_area: ['tiedown', 'custom'],
  ramp_area: ['ramp', 'custom'],
  shade_structure: ['shade', 'conventional_hangar', 'tiedown', 'custom'],
  terminal: ['office', 'storage', 'shop', 'custom'],
  office: ['office', 'storage', 'shop', 'custom'],
  custom: ['conventional_hangar', 'box_hangar', 't_hangar', 'shade', 'tiedown', 'ramp', 'office', 'storage', 'shop', 'custom'],
}
